<template>
  <div class="grey lighten-4 pa-4" style="min-height: 100vh;">
    <v-container>
      <v-card>
        <v-toolbar flat color="blue darken-2" dark>
          <v-toolbar-title>
            <v-icon left>mdi-link-variant</v-icon>
            Links Tec
          </v-toolbar-title>
        </v-toolbar>

        <!-- PC: Tabs -->
        <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab" background-color="blue lighten-5">
          <v-tab v-for="item in sections" :key="item.key" :href="'#' + item.key">
            <v-icon left small>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <!-- Mobile: Select -->
        <div v-else class="pa-3">
          <v-select v-model="tab" :items="sections" item-text="text" item-value="key"
            outlined dense hide-details prepend-inner-icon="mdi-menu">
          </v-select>
        </div>

        <!-- Contenido -->
        <v-tabs-items v-model="tab">
          <v-tab-item value="imagenes">
            <imagenes-comp></imagenes-comp>
          </v-tab-item>
          <v-tab-item value="perfiles">
            <perfiles-comp></perfiles-comp>
          </v-tab-item>
          <v-tab-item value="opciones">
            <opciones-comp></opciones-comp>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'LinksTecHubV',
  components: {
    ImagenesComp: () => import(/* webpackChunkName: "linkstec" */ '@/views/ImagenesBaseV.vue'),
    PerfilesComp: () => import(/* webpackChunkName: "linkstec" */ '@/views/PrincipalV.vue'),
    OpcionesComp: () => import(/* webpackChunkName: "linkstec" */ '@/views/OpcionV.vue'),
  },
  data() {
    return {
      tab: 'imagenes',
      sections: [
        { key: 'imagenes', text: 'Imágenes', icon: 'mdi-image' },
        { key: 'perfiles', text: 'Perfiles', icon: 'mdi-account-circle' },
        { key: 'opciones', text: 'Opciones', icon: 'mdi-cog' },
      ]
    };
  }
};
</script>
